import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class StorageService {
	public constructor(protected storage: Storage) {
		this.storage.create()
	}

	public async set<T>(key: string, value: T): Promise<void> {
		await this.storage.set(key, value);
	}

	public async get<T>(key: string): Promise<T> {
		return await this.storage.get(key);
	}

	public async keys(): Promise<string[]> {
		return await this.storage.keys();
	}

	public async remove(key: string): Promise<void> {
		return await this.storage.remove(key);
	}
}
